import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      email: '',
    }
  },
  methods: {
    reset_password () {
      if (this.loading) {
        return
      }

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$refs.form)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          this.loading = false
          this.success = true
        })
        .catch(error => {
          this.errors.add({ msg: error.response.data.data.message })
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/reset_password.js